import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatUrl } from 'ThreeTerminal_base/publicMethod';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import Ad from '@ifeng-fe/ui_pc_ad';
import { formatWebpUrl } from '../../../../utils/formatWebp';

class Text extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
        isBig: PropTypes.bool,
        imagesInContent: PropTypes.array,
        thumbnails: PropTypes.object,
        handleGalleryOpen: PropTypes.func,
        pageInfo: PropTypes.object,
        pageType: PropTypes.string,
        base62Id: PropTypes.string,
        wxLaunch: PropTypes.object,
        isHitBlack: PropTypes.bool,
        textListAd: PropTypes.object,
    };

    ref = React.createRef();

    isAddCallClient = false;

    getImageSize = async (url) => {
        if (!url) {
            return {};
        }

        return new Promise((resolve, reject) => {
            const myImage = document.createElement('img');

            myImage.style.maxWidth = '100%';
            myImage.style.visibility = 'hidden';
            myImage.style.position = 'absolute';
            myImage.style.left = '-1000px';
            myImage.src = url;
            document.body.appendChild(myImage);

            myImage.onload = () => {
                resolve({
                    width: myImage.offsetWidth,
                    height: myImage.offsetHeight,
                });
                myImage.parentElement.removeChild(myImage);
            };
            myImage.onerror = () => {
                reject({});
                myImage.parentElement.removeChild(myImage);
            };
        });
    };

    getSearchParam = (url, key) => {
        if (!url || !key) return '';

        try {
            const urlObject = new URL(url, window.location.origin);

            return urlObject.searchParams.get(key) || '';
        } catch (e) {
            const searchString = url.split('?')[1] || '';
            const params = new URLSearchParams(searchString.split('#')[0]);

            return params.get(key) || '';
        }
    };

    getIfengAppLink = (parsedData = {}) => {
        if (parsedData.webUrl) return parsedData.webUrl;

        const { type, url } = parsedData;

        if (!url) return '';
        if (type === 'web') return url;

        const searchKeyMap = {
            customPage: 'eventName',
            topic3: 'topicid',
            immersionslide: 'aid',
            pic: 'aid',
            doc: 'aid',
            phvideo: 'guid',
            videoimmersionv2: 'id',
            short: 'aid',
        };
        const searchKey = searchKeyMap[type];

        if (!searchKey) return '';

        let ucmsid = '';

        if (type === 'phvideo') {
            ucmsid = url;
        } else {
            ucmsid = this.getSearchParam(url, searchKey).replace(/^ucms_/, '');
        }

        return ucmsid ? `https://ishare.ifeng.com/c/s/${ucmsid}` : '';
    };

    componentDidMount() {
        Array.from(this.ref.current.querySelectorAll('a[ifengapp-data]')).forEach((item) => {
            const ifengAppData = item.getAttribute('ifengapp-data');
            const parsedData = ifengAppData ? JSON.parse(decodeURIComponent(ifengAppData)) : {};
            const shopLink = this.getIfengAppLink(parsedData);

            if (shopLink) {
                item.setAttribute('href', shopLink);
            }
        });
        // 图片内添加引导
        // this.imageAddCallClient();
    }

    imageAddCallClient = async () => {
        const { pageInfo, base62Id } = this.props;
        const allImageList = Array.from(this.ref.current.querySelectorAll('img')).slice(1);
        let imageFlagNum = -1;

        for (let i = 0; i < allImageList.length; i++) {
            const imageItem = allImageList[i];
            const imgParent = imageItem.parentElement;
            const imageIndex = i;
            let imgSrc = '';

            if (imageItem.getAttribute('data-lazyload')) {
                imgSrc = formatWebpUrl(imageItem.getAttribute('data-lazyload'));
            } else if (imageItem.getAttribute('src')) {
                imgSrc = imageItem.getAttribute('src');
            }

            if (this.isAddCallClient) {
                imgSrc = '';
            }
            const imgageSize = await this.getImageSize(imgSrc);
            const pageWidth = document.body.offsetWidth || window.innerWidth;
            const minImageHeight = 100;

            if (
                pageInfo &&
                pageInfo.base62Id &&
                imgageSize.height &&
                imgageSize.width &&
                pageWidth <= imgageSize.width &&
                imgageSize.height > minImageHeight &&
                !this.isAddCallClient
            ) {
                const divOutDom = document.createElement('div');
                const divInDom = document.createElement('div');
                const divInTextDom = document.createElement('div');
                const client = pageInfo.isVideoShare ? 'videoApp' : 'newsApp';

                divOutDom.className = 'extensionBox';
                divOutDom.style.position = 'relative';
                divInDom.className = 'callUpBox';
                divInTextDom.className = 'callUpBoxTitle';
                divInTextDom.innerText = pageInfo.isVideoShare
                    ? '打开凤凰视频，查看更多高清图片'
                    : '打开凤凰新闻，查看更多高清图片';
                imgParent.insertBefore(divOutDom, imageItem);
                divOutDom.appendChild(imageItem);
                divInDom.appendChild(divInTextDom);
                divOutDom.appendChild(divInDom);

                divOutDom.onclick = () => {
                    this.clickHandle(pageInfo, base62Id, client);
                };

                this.launchAppHandle(divOutDom, pageInfo, base62Id, client);
                this.isAddCallClient = true;
                imageFlagNum = imageIndex;
            }

            if (imgParent.tagName !== 'A' && imageFlagNum !== imageIndex) {
                this.imageNoClick(imageItem);
            }
        }
    };

    imageNoClick = (imageItem) => {
        const { handleGalleryOpen } = this.props;

        imageItem.onclick = (e) => {
            const url = e.currentTarget.getAttribute('data-lazyload') || e.currentTarget.getAttribute('src');
            const index = this.getCurrentIndex(url);

            handleGalleryOpen(index);
        };
    };

    launchAppHandle = (divOutDom, pageInfo, base62Id, client) => {
        const { wxLaunch } = this.props;
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const wxLaunchType = wxLaunch.wxLaunchType;
        const schemeLink =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'doc',
                      pid: pageInfo._id || pageInfo.base62Id,
                  })
                : getSchemeLink({
                      docType: 'doc',
                      pid: pageInfo._id || pageInfo.base62Id,
                      kind: 'share52210',
                  });
        const divWxDom = document.createElement('div');

        divWxDom.style.left = '0';
        divWxDom.style.top = '0';
        divWxDom.style.width = '100%';
        divWxDom.style.height = '100%';
        divOutDom.appendChild(divWxDom);

        ReactDOM.render(
            !pageInfo.isVideoShare && wxLaunchSwitch && (
                <WxLaunchApp
                    launchType={wxLaunchType}
                    parentPosition={'absolute'}
                    launchAppClick={this.clickHandle.bind(this, pageInfo, base62Id, client, true, false, false)}
                    schemeLink={schemeLink}
                    launchAppFail={this.clickHandle.bind(this, pageInfo, base62Id, client, false, true, true)}
                />
            ),
            divWxDom,
        );
    };

    clickHandle = (pageInfo, base62Id, client, isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        const doc_type = 'doc';
        const aid = pageInfo._id || pageInfo.base62Id || '';
        const downloads = pageInfo.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1350561044933',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7495',
              };

        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'seepic',
                    other: {
                        ref: `ucms_${base62Id}`,
                        kind: 'article',
                    },
                },
            ]);
        }

        if (isJumpQQlink) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'seepic',
                    other: {
                        ref: `ucms_${base62Id}`,
                        kind: 'article',
                        tag: 't9',
                    },
                },
            ]);
        }

        if (isCallAppWx) {
            callApp({
                client,
                docType: doc_type,
                pid: aid,
                kind: 'share52210',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    getCurrentIndex = (url) => {
        const { imagesInContent } = this.props;

        url = formatUrl(url);

        for (let i = 0; i < imagesInContent.length; i++) {
            if (imagesInContent[i].url.includes(url)) {
                return i;
            }
        }
    };

    getHiddenFirstImgStyle = (url) => {
        const match = String(url || '').match(/_w(\d+)_h(\d+)/i);
        const aspectRatio = match ? `${match[1]}/${match[2]}` : '';
        const ratioStyle = aspectRatio ? `aspect-ratio:${aspectRatio};` : '';

        return `display:none;max-width:100%;background-color:#f2f2f2;${ratioStyle}`;
    };

    render() {
        const { isBig, content, imagesInContent, pageType, thumbnails, isHitBlack, textListAd } = this.props;

        let firstImg = '';
        let firstSrc = '//p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg';

        if (imagesInContent && imagesInContent[0] && imagesInContent[0].url) {
            firstSrc = imagesInContent[0].url;
        } else if (thumbnails && thumbnails.image && thumbnails.image[0] && thumbnails.image[0].url) {
            firstSrc = thumbnails.image[0].url;
        }

        firstImg = `<img fetchpriority="low" src='${firstSrc}' style="${this.getHiddenFirstImgStyle(firstSrc)}" />`;
        const lazyHtml = content ? firstImg + content : '';

        return (
            <>
                <div
                    className={`${isBig ? styles.bigFont : styles.smallFont}
                            ${styles.text}
                            ${pageType === 'short' ? styles.shortText : ''} articleText`}
                    dangerouslySetInnerHTML={{ __html: lazyHtml }}
                    ref={this.ref}
                />
                {!isHitBlack && textListAd && <Ad content={textListAd} />}
            </>
        );
    }
}

export default Text;
